import { Dimensions } from "~/ui/primitives"

export const GALLERY_MODAL_MAX_WIDTH = "80vw"
export const GALLERY_MODAL_MAX_HEIGHT = "80vh"
const GALLERY_MODAL_VW = 0.8
const GALLERY_MODAL_VH = 0.8
const GALLERY_TOOLBAR_HEIGHT = 52
const GALLERY_MODAL_PADDING = 12

/** 图片/视频预览弹窗尺寸上限与媒体区可用宽高 */
export function getGalleryPreviewBounds() {
  const { width: windowWidth, height: windowHeight } = Dimensions.get("window")
  const maxModalWidth = Math.round(windowWidth * GALLERY_MODAL_VW)
  const maxModalHeight = Math.round(windowHeight * GALLERY_MODAL_VH)
  const innerPadding = GALLERY_MODAL_PADDING * 2
  return {
    maxModalWidth,
    maxModalHeight,
    maxWidth: maxModalWidth - innerPadding,
    maxHeight: maxModalHeight - GALLERY_TOOLBAR_HEIGHT - innerPadding,
    toolbarHeight: GALLERY_TOOLBAR_HEIGHT,
    padding: GALLERY_MODAL_PADDING,
  }
}

/** 根据媒体比例计算弹窗实际宽高（不超过 80vw × 80vh） */
export function getGalleryModalSize(
  mediaWidth: number,
  mediaHeight: number,
  bounds = getGalleryPreviewBounds(),
) {
  const fitted = fitContainSize(mediaWidth, mediaHeight, bounds.maxWidth, bounds.maxHeight)
  const innerPadding = bounds.padding * 2
  return {
    mediaWidth: fitted.width,
    mediaHeight: fitted.height,
    modalWidth: fitted.width + innerPadding,
    modalHeight: fitted.height + bounds.toolbarHeight + innerPadding,
  }
}

/**
 * 等比缩放至不超过 maxWidth / maxHeight。
 * 高超宽以高度为限，宽超则以宽度为限。
 */
export function fitContainSize(
  naturalWidth: number,
  naturalHeight: number,
  maxWidth: number,
  maxHeight: number,
) {
  if (!naturalWidth || !naturalHeight || !maxWidth || !maxHeight) {
    return { width: maxWidth, height: maxHeight }
  }
  const scale = Math.min(maxWidth / naturalWidth, maxHeight / naturalHeight)
  return {
    width: Math.max(1, Math.round(naturalWidth * scale)),
    height: Math.max(1, Math.round(naturalHeight * scale)),
  }
}
